import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              快速解答您的疑问
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                  aria-expanded={openIndex === index}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}